import { classes } from 'html-classes';

import CloudflareResponseImage from '~/components/CloudflareResponsiveImage/CloudflareResponseImage';
import { defaultSrcSetParams } from '~/components/CloudflareResponsiveImage/constants';
import type { CartItem } from '~/stores/CartStore';

import styles from './ProductCard.module.scss';

const ProductCard = ({
  cartItem,
  available,
}: {
  cartItem: CartItem;
  available?: boolean;
}) => (
  <div className={classes([styles.root, available && styles.available])}>
    <div className={styles.preview}>
      <span className={styles.count}>x{cartItem.count}</span>
      <CloudflareResponseImage
        src={cartItem.previewImageThumb}
        srcParams={{ width: 72, height: 72 }}
        srcSetParams={defaultSrcSetParams}
        alt=""
        className={styles.image}
        loading="lazy"
      />
    </div>
    <div className={styles.title}>{cartItem.name}</div>
  </div>
);

export default ProductCard;
